<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('NOTIFICATION_MODULE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>NOTIFICATIONS</h2>
				</div>
				<v-btn @click.prevent="fncReloadNotifications" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
          fncDepartmentAdd() {
              this.$store.dispatch('fncPopulateUserRegions');
				var modalDetails = { title: 'Add Department', component: 'modal-department-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadNotifications() {
           /* this.$store.commit('fncEmptyDepartments');
            this.$store.dispatch({
              type: 'fncPopulateDepartments',
              reload: true
            })*/
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
